import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextLong(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M4 5h16v2H4V5Zm16 4H4v2h16V9Zm0 4H4v2h16v-2Zm-6 4H4v2h10v-2Z" fill="currentColor" />
    </BaseIcon>
  );
}
